<div class="flex align-content-center justify-content-start gap-2 file-item w-full max-w-full">

  <div class="flex align-items-center">
    <img class="file-icon" [src]="file.contentType | fileIcon">
  </div>
  <!-- Name -->
  <div  class="flex flex-grow-1 justify-content-between align-items-center">
    <div class="file-text" *ngIf="!isEdit;">
      <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
        {{file.displayName ?? file.name}}
      </span>
    </div>
    <div id="action-button">
      <button *ngIf="canView"  pButton pRipple type="button" icon="pi pi-eye" class=" p-button-rounded p-button-secondary p-button-text "
      (click)="viewFile()"
      ></button>
      <button *ngIf="canDelete" pButton pRipple type="button" icon="pi pi-trash" class=" p-button-rounded p-button-danger p-button-text "
      (click)="deleteItem()"
      ></button>
    </div>
  </div>
</div>
